import moment, { MomentInput } from 'moment';

export default function plusMilliseconds(date: MomentInput, millisecondsCount: number, outputIsoString = true): string {
  const milliseconds = moment(date).valueOf();
  const result = milliseconds + millisecondsCount;
  return outputIsoString ? moment(result).toISOString() : moment().toLocaleString();
}
